import { mapValues } from 'lodash';
import {
  QuizPinAnswer,
  QuizPinAnswerImage,
  QuizPinAnswerText,
  QuizPinLayoutTemplate,
  QuizTeacherPin,
} from '../../models';
import { stringToLeanProsemirror } from '../../tip-tap';
import { PinCreationParams } from './pin-helper-types';

export type QuizPinAnswerTextProps = Omit<QuizPinAnswerText, 'text'> & { text: string };
export type QuizPinAnswerProps = QuizPinAnswerImage | QuizPinAnswerTextProps;

export const newQuizPin = (
  layout: QuizPinLayoutTemplate,
  correctAnswers: string[] = [],
  answers: QuizPinAnswerProps[] = [
    { type: 'TEXT', text: 'Answer A', id: 'A' },
    { type: 'TEXT', text: 'Answer B', id: 'B' },
    { type: 'TEXT', text: 'Answer C', id: 'C' },
    { type: 'TEXT', text: 'Answer D', id: 'D' },
  ]
): PinCreationParams<QuizTeacherPin> => {
  const basePin: PinCreationParams<QuizTeacherPin> = {
    type: 'MULTIPLE_CHOICE',
    settings: {
      layout: layout.key,
      backgroundColor: layout.backgroundColor,
      backgroundImage: layout.backgroundImage,
      answers: transformQuizPinAnswers(answers),
      layoutParts: mapValues(layout.layoutParts, (comp) => comp?.id),
      questionId: layout.layoutParts.TITLE?.id,
    },
    teacherSettings: {
      correctAnswers: correctAnswers || [],
    },
    pinComponents: [...Object.values(layout.layoutParts), ...layout.pinComponents],
  };

  if ('backgroundTransparency' in layout && layout.backgroundTransparency !== undefined) {
    basePin.settings.backgroundTransparency = layout.backgroundTransparency;
  }

  return basePin;
};

function transformQuizPinAnswers(answers: QuizPinAnswerProps[]): QuizPinAnswer[] {
  return answers.map((answer) => {
    if (answer.type === 'TEXT') {
      return { ...answer, text: stringToLeanProsemirror(answer.text) };
    }
    return answer;
  });
}
